// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"163":"2fa9fd2e","545":"a893f900"}[chunkId] + ".chunk.css";
};